import React from 'react';
import LandingButton from './LandingButton';
import SpecularButton from './SpecularButton';
import LandingSection from './LandingSection';
import Reveal from './Reveal';
import { SIGNUP_URL, CONTACT_EMAIL } from './urls';
import { useT } from './i18n';

const LandingCTA = () => {
  const t = useT();
  return (
  <LandingSection variant="gray" size="compact">
    <Reveal>
      <div className="landing-cta landing-cta--aurora">
        <div className="landing-cta__aurora" aria-hidden />
        <div className="landing-cta__content">
        <h2 className="landing-h2" style={{ color: '#fff' }}>
          {t('cta.title')}
        </h2>
        <p>
          {t('cta.textBefore')}{' '}
          <a href={SIGNUP_URL} className="landing-cta__link">{t('cta.textLink')}</a>
          {t('cta.textAfter')}
        </p>
        <div className="landing-row landing-row--center">
          <SpecularButton
            href={SIGNUP_URL}
            size="lg"
            className="specular-button--light"
            radius={10}
            lineColor="#2563eb"
            baseColor="#93c5fd"
            intensity={1}
            shineSize={12}
            shineFade={44}
            thickness={1.2}
            proximity={300}
            followMouse
          >
            {t('cta.tryFree')}
          </SpecularButton>
          <LandingButton
            variant="secondary"
            size="lg"
            href={CONTACT_EMAIL}
            className="landing-btn--outline-white"
          >
            {t('cta.contact')}
          </LandingButton>
        </div>
        </div>
      </div>
    </Reveal>
  </LandingSection>
  );
};

export default LandingCTA;
